import { IMDSPopoverProps } from "./popover.types";
import { StyledPopover } from "./popover.style";

export const MDSPopover = (props: IMDSPopoverProps) => {
  return <StyledPopover {...props} />;
};
